module.exports = function() {
  return new Worker("/" + "pug-transpiler.473f574a.worker.js");
};